'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _EventDetailClassicLayout = require('./EventDetailClassicLayout');

var _EventDetailClassicLayout2 = _interopRequireDefault(_EventDetailClassicLayout);

var _EventDetailModernLayout = require('./EventDetailModernLayout');

var _EventDetailModernLayout2 = _interopRequireDefault(_EventDetailModernLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventDetail = function EventDetail(props) {
  var audienceAction = props.audienceAction,
      children = props.children,
      groupAction = props.groupAction,
      tagAction = props.tagAction,
      backButtonAction = props.backButtonAction,
      event = props.event,
      layout = props.layout,
      mapApiKey = props.mapApiKey,
      selectedDateProp = props.selectedDate,
      typeAction = props.typeAction;


  var selectedDateString = selectedDateProp || (0, _moment2.default)(event.dates[0].start_date).format('YYYY-MM-DD_HH-mm-ss');
  var selectedDate = event.dates.find(function (date) {
    return (0, _moment2.default)(date.start_date).format('YYYY-MM-DD_HH-mm-ss') === selectedDateString;
  });

  var layoutProps = {
    audienceAction: audienceAction,
    backButtonAction: backButtonAction,
    groupAction: groupAction,
    contact: {
      name: event.contact_name,
      email: event.contact_email,
      phone: event.contact_phone,
      url: event.contact_url
    },
    event: event,
    layout: layout,
    price: {
      type: event.price_type,
      notes: event.price_notes,
      prices: event.prices
    },
    map: {
      latitude: event.venue.latitude,
      longitude: event.venue.longitude,
      apiKey: mapApiKey
    },
    selectedDate: selectedDate,
    tagAction: tagAction,
    typeAction: typeAction
  };

  if (children) {
    return children(layoutProps);
  }

  switch (layout) {
    case 'modern':
      return _react2.default.createElement(_EventDetailModernLayout2.default, layoutProps);
    default:
      return _react2.default.createElement(_EventDetailClassicLayout2.default, layoutProps);
  }
};

EventDetail.propTypes = {
  /** Action triggered when the Back button is clicked */
  backButtonAction: _propTypes2.default.func,
  /** Optional child elements to be rendered instead of built-in layouts */
  children: _propTypes2.default.node,
  /** Event object in the Caligram API format. */
  event: _propTypes2.default.object.isRequired,
  /** The layout to use */
  layout: _propTypes2.default.string,
  /** The Google Static Maps API key. */
  mapApiKey: _propTypes2.default.string.isRequired,
  /** The selected date as used in the query string. */
  selectedDate: _propTypes2.default.string,
  /** Function called when an audience is clicked. */
  audienceAction: _propTypes2.default.func,
  /** Function called when a group is clicked. */
  groupAction: _propTypes2.default.func,
  /** Function called when a tag is clicked. */
  tagAction: _propTypes2.default.func,
  /** Function called when a type is clicked. */
  typeAction: _propTypes2.default.func
};

EventDetail.defaultProps = {
  audienceAction: function audienceAction() {},
  backButtonAction: function backButtonAction() {},
  children: null,
  groupAction: function groupAction() {},
  layout: 'classic',
  selectedDate: null,
  tagAction: function tagAction() {},
  typeAction: function typeAction() {}
};

exports.default = EventDetail;
EventDetail.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'EventDetail',
  'props': {
    'audienceAction': {
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Function called when an audience is clicked.'
    },
    'backButtonAction': {
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Action triggered when the Back button is clicked'
    },
    'children': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'node'
      },
      'required': false,
      'description': 'Optional child elements to be rendered instead of built-in layouts'
    },
    'groupAction': {
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Function called when a group is clicked.'
    },
    'layout': {
      'defaultValue': {
        'value': '\'classic\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The layout to use'
    },
    'selectedDate': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The selected date as used in the query string.'
    },
    'tagAction': {
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Function called when a tag is clicked.'
    },
    'typeAction': {
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Function called when a type is clicked.'
    },
    'event': {
      'type': {
        'name': 'object'
      },
      'required': true,
      'description': 'Event object in the Caligram API format.'
    },
    'mapApiKey': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'The Google Static Maps API key.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventDetail.js
// module id = 584
// module chunks = 0